import React from 'react'
import MovieGPTContainer from '../component/MovieGPTContainer'

export const SuggestionsTab = () => {
  return (
    <MovieGPTContainer/>
  )
}
